import { ROLES_NAMES } from 'constants/common'
import { ROLES } from 'features/Permission'

import { TProxyVoter } from './types'

const SUBMITTED_BY_PREFIX = 'Submitted by: '

//  Full “Submitted by: …” line for survey proxy voter (CC vs sourcing owner vs role name).
export const getSurveyProxySubmittedByLabel = (
  proxyVoter: Pick<TProxyVoter, 'uuid' | 'role'> | null | undefined,
  rfpCreatorUuid?: string | null
): string => {
  if (!proxyVoter) return ''
  if (proxyVoter.role === ROLES.CLINICAL_COORDINATOR) {
    return `${SUBMITTED_BY_PREFIX}${ROLES_NAMES[ROLES.CLINICAL_COORDINATOR]}`
  }
  if (rfpCreatorUuid && proxyVoter.uuid === rfpCreatorUuid) {
    return `${SUBMITTED_BY_PREFIX}Sourcing Owner`
  }
  return `${SUBMITTED_BY_PREFIX}${ROLES_NAMES[proxyVoter.role] ?? ''}`
}
